// Utilities for normalizing text selection within document segments
// Relies on selectionUtils helpers to locate segment elements and compute offsets.

import {getOffsetWithinSegment, getSegmentElementFromNode, parseIndexFromSegmentId,} from './selectionUtils';

// Compute total text length of a segment element (consistent with getOffsetWithinSegment)
export function getSegmentTextLength(segmentEl) {
    if (!segmentEl) return 0;
    const walker = window.document.createTreeWalker(segmentEl, NodeFilter.SHOW_TEXT);
    let total = 0;
    let current;
    // eslint-disable-next-line no-cond-assign
    while ((current = walker.nextNode())) {
        total += current.nodeValue?.length ?? 0;
    }
    return total;
}

// Normalize selection across segments. Fixes triple-click where the end lands at offset 0 of the next segment.
export function computeNormalizedSelection(range, contentElement) {
    if (!range || !contentElement) return null;

    const startSegmentEl = getSegmentElementFromNode(contentElement, range.startContainer);
    const endSegmentElRaw = getSegmentElementFromNode(contentElement, range.endContainer);
    const startIndex = parseIndexFromSegmentId(startSegmentEl?.id);
    let endIndex = parseIndexFromSegmentId(endSegmentElRaw?.id);
    if (startIndex == null || endIndex == null) return null;

    const startOffset = startSegmentEl
        ? getOffsetWithinSegment(startSegmentEl, range.startContainer, range.startOffset)
        : 0;
    let endOffset = endSegmentElRaw
        ? getOffsetWithinSegment(endSegmentElRaw, range.endContainer, range.endOffset)
        : startOffset;

    // If end is exactly at the start of the next segment, pull it back to the previous segment end.
    if (endIndex > startIndex && endOffset === 0) {
        const prevIndex = endIndex - 1;
        const prevEl = contentElement.querySelector(`#segment-${prevIndex}`);
        if (prevEl) {
            endIndex = prevIndex;
            endOffset = getSegmentTextLength(prevEl);
        }
    }

    return {startIndex, startOffset, endIndex, endOffset};
}

